import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-two-factor-authentication',
  standalone: true,
  imports: [],
  templateUrl: './two-factor-authentication.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './two-factor-authentication.component.scss'
})
export class TwoFactorAuthenticationComponent {


  ngOnDestroy(): void {}
}